import { XMLParser } from 'fast-xml-parser'

// fast-xml-parser
// See: https://github.com/NaturalIntelligence/fast-xml-parser/blob/master/docs/v4/2.XMLparseOptions.md
const parserOptions = {
  allowBooleanAttributes: true,

  // Treat certain nodes as arrays, even if they only have one value
  isArray: (tagName: string, fullPath: string) => {
    // console.debug('isArray', tagName, path)

    const inclusions = [
      // WMS Capabilties
      'DCPType', 'Keyword', 'Layer', 'LegendURL', 'Style',

      // QGIS Project Settings specific
      'Attribute', 'WFSLayer'
    ]

    const exclusions = [
      'WMS_Capabilities.Capability.Layer'
    ]

    return inclusions.includes(tagName) && !exclusions.includes(fullPath)
  },

  attributeNamePrefix: '',
  ignoreAttributes: false,
  ignoreDeclaration: true, // Remove <?xml ... ?>
  removeNSPrefix: true

  // We currently cannot control the output of the following node:
  //
  // <OnlineResource href="https:/...." />
  //
  // We ideally would like to return something like:
  // {
  //   OnlineResource: 'https:/....'
  // }
  //
  // instead of {
  //   OnlineResource: {
  //     href: 'https:/....'
  //   }
  // }
  //
  // Hopefully one day, the following function can take an 'empty' node with attributes
  // but currently (at 2022-07-27 at version v4.0.9) this seems not possible
  //
  // tagValueProcessor: (tagName: string, tagValue: any, jPath: string, hasAttributes: boolean, isLeafNode: boolean) => {
  //   console.log('tagValueProcessor ', tagName, jPath, tagValue, hasAttributes)

  //   if (tagName === 'OnlineResource') {
  //     console.warn('tagValueProcessor onlineresource', tagName, tagValue, hasAttributes)
  //   }

  //   return tagValue
  // }
}

const xmlParser = new XMLParser(parserOptions)

export default class QGISProjectSettingsParser {
  read (source: string) {
    try {
      const capabilitiesObject = xmlParser.parse(source).WMS_Capabilities

      // console.debug('QGISProjectSettingsParser result', capabilitiesObject)

      return capabilitiesObject
    } catch (error: any) {
      console.error('QGISProjectSettingsParser - parsing failed', error)
      throw new Error(`QGISProjectSettingsParser - parsing failed: ${error.message}`)
    }
  }
}
